import { render, staticRenderFns } from "./CopyAction.vue?vue&type=template&id=6128d422&"
import script from "./CopyAction.vue?vue&type=script&lang=js&"
export * from "./CopyAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports